var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgListView = function SvgListView(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 13,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18.6,
    height: 11.6,
    x: 0.7,
    y: 0.7,
    stroke: "#6777FF",
    strokeWidth: 1.4,
    rx: 1.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#6777FF",
    strokeWidth: 1.4,
    d: "M1 4.3h18M6.7 0v13M1 8.3h18"
  })));
};
export default SvgListView;